//  @flow

import React from 'react';

type QueriesProps = {
  text: string,
  link: string,
  onClick: () => void
};

const Queries = (props: QueriesProps) => (
  <a
    id="alienbrains-query"
    href={props.link}
    className="query"
    onClick={props.onClick}>
    {props.text}
  </a>
);

export default Queries;



// WEBPACK FOOTER //
// ./src/Pages/Home/Queries.js